// UI store — theme, locale, drawer, snackbar (doc 04 §6.1).
import { defineStore } from 'pinia'
import { ref } from 'vue'

export type SnackbarColor = 'success' | 'info' | 'warning' | 'error'

export interface Snackbar {
  show: boolean
  message: string
  color: SnackbarColor
}

const THEME_KEY = 'cpa.theme'
const LOCALE_KEY = 'cpa.locale'

export const useUiStore = defineStore('ui', () => {
  const theme = ref<'cpaLight' | 'cpaDark'>(
    (localStorage.getItem(THEME_KEY) as 'cpaLight' | 'cpaDark' | null) ??
      'cpaLight',
  )
  const locale = ref<string>(
    localStorage.getItem(LOCALE_KEY) ??
      import.meta.env.VITE_DEFAULT_LOCALE ??
      'en',
  )
  const drawer = ref(false)
  const snackbar = ref<Snackbar>({ show: false, message: '', color: 'info' })

  function toast(message: string, color: SnackbarColor = 'info') {
    snackbar.value = { show: true, message, color }
  }

  function toggleDrawer(value?: boolean) {
    drawer.value = value ?? !drawer.value
  }

  function setLocale(next: string) {
    locale.value = next
    localStorage.setItem(LOCALE_KEY, next)
  }

  function setTheme(next: 'cpaLight' | 'cpaDark') {
    theme.value = next
    localStorage.setItem(THEME_KEY, next)
  }

  return {
    theme,
    locale,
    drawer,
    snackbar,
    toast,
    toggleDrawer,
    setLocale,
    setTheme,
  }
})
